module.exports = __webpack_public_path__ + "img/portfolio-04.228ba94c.jpg";